'use strict';

angular.module('membership')
  .service('partnershipDetailsViewModel', [
    'Customer', 'MembershipLookup',
    function (Customer, Lookup) {

      var viewModel = function (item) {

        var self = this;

        self.listeners = {};
        self.item = item || {};

        Lookup.partners().then(function (data) {
          self.partners = data;
        });

        self.on = function (action, callBack) {
          self.listeners[action] = callBack;
        };

        self.notify = function (action, params) {
          if (self.listeners[action]) {
            self.listeners[action](params);
          }
        };

        self.save = function () {
          Customer.savePartnership(self.item).then(function () {
            self.notify('save');
          });
        };

        self.delete = function () {
          Customer.deletePartnership(self.item).then(function () {
            self.notify('delete', { Id: self.item.Id });
          });
        };

      };

      return viewModel;

    }
  ]);
